import type { RouteRecordRaw } from 'vue-router'
import { $t } from '@/locales'

function Layout() {
  return import('@/layouts/index.vue')
}

// 意图识别管理
const intent: RouteRecordRaw = {
  path: '/core/intent',
  name: 'intent',
  meta: {
    title: $t('route.intent.title'),
    icon: 'carbon:intent-request-inactive',
  },
  component: () => import('@/views/core/intent/intentIndex.vue'),
}

// FAQ管理
const FAQ: RouteRecordRaw = {
  path: '/core/FAQ',
  name: 'FAQ',
  meta: {
    title: $t('route.FAQ.title'),
    icon: 'streamline-ultimate:contact-us-faq',
  },
  component: () => import('@/views/core/FAQ/FAQindex.vue'),
}

// 内容组件管理
const content: RouteRecordRaw = {
  path: '/core/content',
  name: 'content',
  meta: {
    title: $t('route.content.title'),
    icon: 'proicons:component',
  },
  component: () => import('@/views/core/content/contentIndex.vue'),
}

// CTA管理
const CTA: RouteRecordRaw = {
  path: '/core/CTA',
  name: 'CTA',
  meta: {
    title: $t('route.CTA.title'),
    icon: 'mdi:cta',
  },
  component: () => import('@/views/core/CTA/CTAIndex.vue'),
}

/**
 * 核心功能模块 <FaIcon name="i-ep:home-filled" />
 */
const routes: RouteRecordRaw = {
  path: '/core',
  component: Layout,
  name: 'core',
  meta: {
    title: $t('route.core.title'),
    icon: 'icomoon-free:fire',
    alwaysOpened: true,
  },
  children: [
    intent,
    FAQ,
    content,
    CTA,
  ],
}
export default routes
